<template>
  <div v-if="show" class="row col-12 justify-content-center align-items-center">
    <b-form-group label="Sélectionner la période :" class="col-4">
      <b-row>
        <b-row>
          <b-form-datepicker
            v-model="startDate"
            placeholder="Date de début"
            :state="Boolean(startDate)"
          ></b-form-datepicker>
        </b-row>
        <b-row>
          <b-form-datepicker
            v-model="endDate"
            placeholder="Date de fin"
            :state="Boolean(endDate)"
          ></b-form-datepicker>
        </b-row>
      </b-row>
    </b-form-group>

    <b-form-group label="Sélectionner un client :" class="col-4">
      <b-form-select
        v-model="selectedClient"
        :options="clientOptions"
        placeholder="Choisir un client"
        :state="Boolean(selectedClient)"
      ></b-form-select>
    </b-form-group>

    <div class="col-1 justify-content-center">
      <b-button variant="primary" @click="search">Rechercher</b-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false,
        startDate: null,
        endDate: null,
        selectedClient: null,
        clientOptions: [{ value: null, text: 'Choisir un client' }],
      }
    },
    props: ['clients'],
    methods: {
      feadClientOptions() {
        this.clients.forEach((client) => {
          console.log(client._id, client.name)
          this.clientOptions.push({
            value: client._id,
            text: client.name,
            roomId: client.roomsId,
          })
        })
        this.show = true
      },
      search() {
        this.$emit('search', {
          startDate: this.startDate,
          endDate: this.endDate,
          selectedClient: this.selectedClient,
        })
      },
    },
    mounted() {
      this.feadClientOptions()
    },
  }
</script>

<style>
  /* Ajoutez des styles personnalisés ici si nécessaire */
</style>
